<script setup lang="ts">
defineProps<{
  table?: string[][]
}>()
</script>

<template>
  <div class="relative w-full overflow-x-auto border border-gray-200 sm:rounded-md">
    <table
      v-if="table?.[0]"
      class="w-full text-left text-sm text-gray-500 dark:text-gray-400"
    >
      <thead class="text-xs text-gray-700 font-bold uppercase dark:text-gray-400">
        <tr class="text-center">
          <th
            v-for="(header, hi) in table[0]" :key="hi"
            class="bg-gray-200 px-6 py-3 text-center text-xs text-gray-900 font-bold tracking-wider uppercase dark:bg-gray-800"
          >
            {{ header }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(row, ri) in table.slice(1)" :key="ri" :class="{ 'bg-gray-50 dark:bg-gray-800': ri % 2 === 0, 'bg-white dark:bg-gray-700': ri % 2 !== 0 }">
          <td
            v-for="(cell, ci) in row" :key="ci"
            class="whitespace-nowrap px-6 py-4 text-center text-gray-900 font-medium dark:text-white"
            v-text="cell"
          />
        </tr>
      </tbody>
    </table>
  </div>
</template>
